<template>
    <div id="licence">
        <b-row class="backInfoMain">
            <!--backInfoMain-->
            <b-col :xs="pSize.left.xs" :sm="pSize.left.sm" :md="pSize.left.md" :lg="pSize.left.lg" :xl="pSize.left.xl">
                    <!--Recherche de licence-->
                    <div class="backInfoCornerS">
                        <b-row class="addLicContainer">
                            <!--Ajout de licence-->
                                <!--Ajout-->
                                <b-form-input v-show="!output" class="addLicence" :state="nomLicence.length > 2 ? true : false" id="nomLicence" name="nomLicence" type="text" maxlength="40" :placeholder="$t('p_NomLicence')" v-model="nomLicence"></b-form-input>
                                <b-button v-show="!output" type="button" class="btnSearch" :disabled="nomLicence.length > 2 ? false : true" @click="formSubmit()">{{$t('p_Creer')}}</b-button>
                                <!--Confirmation et bouton nouveau-->
                                <b-alert :variant="getTheme.success" class="addLicence" :show="output">{{$t('msg_SaveSuccess')}}</b-alert>
                                <b-button v-show="output" type="button" class="btnSearch" @click="resetLicence">{{$t('g_Nouveau')}}</b-button>
                            <!--Recherche de licence-->
                            <b-form-input class="addLicence" id="search" name="search" type="text" :placeholder="$t('p_Recherche')" v-model="txtRecherche"></b-form-input>
                            <b-button type="button" class="btnSearch" @click="txtRecherche = ''">{{$t('g_Efface')}}</b-button>
                            <b-button type="button" class="btnPaiement" :variant="getTheme.info" @click="showPage=4">{{$t('p_Paiement')}}</b-button>
                        </b-row>

                    </div>

                    <!--Tableau d'affichage de la liste des licence ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
                    <div class="backInfoCornerS">
                        <b-table v-if="showPage != '4'" striped hover :bordered="true" :head-variant="getTheme.dark" :items="filteredLicence" :fields="fields" class="tblWidth">
                            <template v-slot:cell(details)="row">
                                <!--Bouton : Voir détials-->
                                <b-button-group size="sm">

                                    <b-button id="showDetails" size="sm" @click="showDetails(row)">
                                        <b-icon icon="eye-fill" :variant="getTheme.light" font-scale="1.5"></b-icon>
                                    </b-button>

                                    <b-button id="createLicence" size="sm" @click="creatLicence(row)" class="addBtn">
                                        <b-icon icon="plus" :variant="getTheme.dark" font-scale="1.5"></b-icon>
                                    </b-button>

                                    <b-button id="addPaiement" size="sm" @click="addPaiement(row)">+$</b-button>

                                </b-button-group>
                            </template>
                        </b-table>
                    </div>
                    <!--FIN - Tableau d'affichage de la liste des licence ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
            </b-col>

<!--Fin section de gauche-->
<!--****************************************************************************************************************************************************************-->
<!--Section de droite-->

            <!--Détails des licences ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
            <b-col :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" :xl="pSize.right.xl" v-if="showPage == '1'">
                <div class="backInfoCornerSB">
                    <p class="titleBtn1" @click="resetAll(true)"><b-icon icon="arrow-left" :variant="getTheme.dark" font-scale="1" animation="cylon"></b-icon> {{$t('g_Retour')}}</p>
                    <p class="title">({{licenceDetail.item.id}}) {{licenceDetail.item.licence}}</p>
                    <h4>{{licenceDetail.item.nomLicence}}</h4>
                    <h5>{{$t('p_QteMagasin')}} : {{licenceDetail.item.qteMag}}</h5>

                    <div v-for="(mag, index) in licenceDetail.item.Magasin" :key="mag.index">
                        <p :class="licenceDetail.item.Magasin[index].actif ? 'subTitle' : 'subTitleInactive'">{{licenceDetail.item.Magasin[index].nom}}</p>
                        <h6 class="subTitle2">{{$t('p_NumeroMag')}} : {{licenceDetail.item.Magasin[index].magNumber}}</h6>
                       
                        <s-line></s-line>
                        <h6>{{licenceDetail.item.Magasin[index].add1}}</h6>
                        <h6>{{licenceDetail.item.Magasin[index].add2}}</h6>
                        <h6>{{licenceDetail.item.Magasin[index].zipCode}}</h6>
                        <h6 class="addBold">{{licenceDetail.item.Magasin[index].tel}}</h6>
                        <s-line></s-line>

                        <!--PAIEMENT-->
                        <span v-if="licenceDetail.item.Magasin[index].paiementVL==0">
                            <span class="mensuel">{{$t('p_Location')}}</span>
                            <h6 class="txtStandard"><span class="addBold">{{$t('p_Paiement')}} : </span>
                                <span v-if="licenceDetail.item.Magasin[index].paiement==0">
                                    <span class="mensuel">{{$t('p_Mensuel')}}</span>
                                </span>
                                <span v-else-if="licenceDetail.item.Magasin[index].paiement==1">
                                    <span class="annuel">{{$t('p_Annuel')}}</span>
                                </span>
                            </h6>
                            <br>
                            <h6 class="txtStandard"><span class="addBold">{{$t('p_Montant')}} : </span>{{$FM(licenceDetail.item.Magasin[index].paiementMontant,2)}}</h6>
                            <h6 class="txtStandard"><span class="tx">{{$t('g_TPS')}} : {{$TPS(licenceDetail.item.Magasin[index].paiementMontant,2)}}</span></h6>
                            <h6 class="txtStandard"><span class="tx">{{$t('g_TVQ')}} : {{$TVQ(licenceDetail.item.Magasin[index].paiementMontant,2)}}</span></h6>
                            <h6 class="txtStandard"><span class="addBold">{{$t('g_Total')}} : </span>{{$AddTaxe(licenceDetail.item.Magasin[index].paiementMontant,2)}}</h6>
                            <br>
                            <span v-if="licenceDetail.item.Magasin[index].paiement==1">
                                <h6 class="txtStandard">{{$t('p_Mensuel')}} : {{$FM((licenceDetail.item.Magasin[index].paiementMontant / 12),2, '.', ' ')}}</h6>
                            </span>

                        </span>

                        <span v-if="licenceDetail.item.Magasin[index].paiementVL==1">
                            <span class="annuel">{{$t('p_Vente')}}</span>
                        </span>

                        <span v-if="licenceDetail.item.Magasin[index].paiementNote!=''">
                            <br>
                            <h6 class="txtStandard"><span class="addBold">{{$t('p_Note')}} : </span>{{licenceDetail.item.Magasin[index].paiementNote}}</h6>
                        </span>

                        <s-line></s-line>
                        <!--FIN - PAIEMENT-->

                        <h6 class="txtStandard" v-show="licenceDetail.item.Magasin[index].modeDemo">{{$t('p_LicDemo')}}</h6>
                        <h6 class="txtStandard" v-show="licenceDetail.item.Magasin[index].tpv">{{$t('p_Tpv')}}</h6>
                        <h6 class="txtStandard" v-show="licenceDetail.item.Magasin[index].wooCommerce">{{$t('p_wooCommerce')}}</h6>
                        <h6 class="txtStandard" v-show="licenceDetail.item.Magasin[index].inventaire">{{$t('p_Inventaire')}}</h6>
                        <h6 class="txtStandard" v-show="licenceDetail.item.Magasin[index].ecranPub">{{$t('p_EcranPub')}}</h6>
                        <h6 class="txtStandard" v-show="licenceDetail.item.Magasin[index].compteClient">{{$t('p_CompteClient')}}</h6>
                        <h6 class="txtStandard" v-show="licenceDetail.item.Magasin[index].horodateur">{{$t('p_Horodateur')}}</h6>
                        <h6 class="txtStandard" v-show="licenceDetail.item.Magasin[index].etiquette">{{$t('p_Etiquette')}}</h6>
                        <h6 class="txtStandard" v-show="licenceDetail.item.Magasin[index].certCadeaux">{{$t('p_CertCadeaux')}}</h6>
                        <br>
                        <h6 class="subTitle2">{{$t('p_Note')}}</h6>
                        <h6 class="txtStandard">{{licenceDetail.item.Magasin[index].licNote}}</h6>
                        <p class="subTitle"></p>
                        <b-button id="modifier" :variant="getTheme.warning" class="btnModif" size="xl" @click="modifLicence(index)">{{$t('g_Modifier')}}</b-button>
                    </div>
                </div>
            </b-col>
            <!--FIN - Détails des licences ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->

            <!--Création de la licence ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
            <b-col :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" :xl="pSize.right.xl" v-if="showPage == '2' || showPage == '3'">
                <div class="backInfoCornerSB">
                    <p class="titleBtn1" @click="resetAll(true)"><b-icon icon="arrow-left" :variant="getTheme.dark" font-scale="1" animation="cylon"></b-icon> {{$t('g_Retour')}}</p>
                    <!--Création de la base de données-->
                    <div v-if="outputDbCreate == null"></div>                    
                    <div v-else-if="outputDbCreate == false">
                        <h4>{{$t('msg_CreationEnCour')}}</h4>
                        <b-spinner small type="grow" :variant="getTheme.warning"></b-spinner>
                        <b-spinner type="grow" :variant="getTheme.danger"></b-spinner>
                        <b-spinner small type="grow" :variant="getTheme.warning"></b-spinner>
                        <h5>{{$t('msg_QuelqueMinute')}}</h5>
                    </div>
                    <div v-else-if="outputDbCreate == true"><h3>{{$t('msg_CreateSuccess')}}</h3></div>
                    <!--FIN - Création de la base de données-->
                    <p class="title">{{licenceDetail.item.licence}}</p>
                    <p class="subTitle">{{$t('p_Informations')}}</p>
                    <div class = "backForm2">
                        <b-form-input :state="nomCommerce.length > 3 ? true : false" class="text" id="nomCommerce" name="nomCommerce" type="text" maxlength="40" :placeholder="$t('p_NomCommerce')" v-model="nomCommerce"></b-form-input>
                        <b-form-input :state="adresse.length > 5 ? true : false" class="text" id="adresse" name="adresse" type="text" maxlength="40" :placeholder="$t('p_Adresse')" v-model="adresse"></b-form-input>
                        <b-form-input :state="ville.length > 1 ? true : false" class="text" id="ville" name="ville" type="text" maxlength="40" :placeholder="$t('p_Ville')" v-model="ville"></b-form-input>
                        <b-form-input :state="zipCode.length > 5 ? true : false" class="text" id="zipCode" name="zipCode" type="text" maxlength="6" :placeholder="$t('p_ZipCode')" v-model="zipCode"></b-form-input>
                        <b-form-input :state="tel.length > 7 ? true : false" class="text" id="tel" name="tel" type="text" maxlength="15" :placeholder="$t('p_Tel')" v-model="tel"></b-form-input>
                        <b-form-textarea class="text" id="note" rows="8" cols="20" :placeholder="$t('p_Note')" v-model="note"></b-form-textarea>
                    </div>

                    <!--PAIEMENT-->
                    <p class="subTitle">{{$t('p_Paiement')}}</p>
                    <div class = "backForm2 aLeft">
                        <label>{{$t('p_Montant')}}</label>
                        <b-form-input class="qtePos" id="paieMontant" name="paieMontant" type="number" min="1" max="99999" v-model="paiementMontant"></b-form-input>
                        <s-duoSelector style="margin-left: -15px" :text1="$t('p_Mensuel')" :text2="$t('p_Annuel')" :value="paiement" :returnValue.sync="paiement"></s-duoSelector>
                        <s-duoSelector style="margin-left: -15px" :text1="$t('p_Location')" :text2="$t('p_Vente')" :value="paiementVL" :returnValue.sync="paiementVL"></s-duoSelector>
                        <b-form-input style="margin-top: 10px" class="text" id="paieNote" name="paieNote" type="text" maxlength="200" :placeholder="$t('p_Note')" v-model="paiementNote"></b-form-input>
                    </div>

                    <!--OPTIONS-->
                    <p class="subTitle">{{$t('p_Options')}}</p>
                    <div class = "backForm2 aLeft">
                        <label>{{$t('p_QtePos')}}</label>
                        <b-form-input class="qtePos" id="qtePos" name="qtePos" type="number" min="1" max="99" v-model="qtePos"></b-form-input>
                        <p class="subTitle"></p>
                        <b-form-checkbox switch notEnabled=true v-model="actif">{{$t('p_Actif')}}</b-form-checkbox>
                        <p class="subTitle"></p>
                        <b-form-checkbox switch notEnabled=true v-model="modeDemo">{{$t('p_LicDemo')}}</b-form-checkbox>
                        <b-form-checkbox switch v-model="tpv">{{$t('p_Tpv')}}</b-form-checkbox>
                        <b-form-checkbox switch v-model="wooCommerce">{{$t('p_wooCommerce')}}</b-form-checkbox>
                        <b-form-checkbox switch v-model="inventaire">{{$t('p_Inventaire')}}</b-form-checkbox>
                        <b-form-checkbox switch v-model="ecranPub">{{$t('p_EcranPub')}}</b-form-checkbox>
                        <b-form-checkbox switch v-model="compteClient">{{$t('p_CompteClient')}}</b-form-checkbox>
                        <b-form-checkbox switch v-model="horodateur">{{$t('p_Horodateur')}}</b-form-checkbox>
                        <b-form-checkbox switch v-model="etiquette">{{$t('p_Etiquette')}}</b-form-checkbox>
                        <b-form-checkbox switch v-model="certCadeaux">{{$t('p_CertCadeaux')}}</b-form-checkbox>
                        <b-button class="btnAllNone" @click="selectOption(true)">{{$t('g_Tous')}}</b-button>
                        <b-button class="btnAllNone" @click="selectOption(false)">{{$t('g_Aucun')}}</b-button>
                    </div>
                    <p class="subTitle"></p>
                    <div class = "backForm2 aLeft">
                        <b-button class="btnReset" :variant="getTheme.danger" @click="resetAll(false)">{{$t('g_Efface')}}</b-button>
                        <b-button :disabled="checkCreateMagasin" type="button" class="btnSave" :variant="getTheme.success" @click="sendMagForm()">{{$t('g_Enregistrer')}}</b-button>
                    </div>
                </div>
            </b-col>
            <!--FIN - Création de la licence ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->


            <!--Ajout de paiement ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
            <b-col :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" :xl="pSize.right.xl" v-if="showPage == '5'">
                <div class="backInfoCornerSB">
                    <p class="titleBtn1" @click="resetAll(true)"><b-icon icon="arrow-left" :variant="getTheme.dark" font-scale="1" animation="cylon"></b-icon> {{$t('g_Retour')}}</p>

                    <!--PAIEMENT-->
                    <p class="title">{{$t('p_AjoutDePaiement')}}</p>
                    <div class = "backForm2 aLeft">
                        <label>{{$t('p_Montant')}}</label>
                        <s-currencyInput class="qtePos" id="paieMontant" name="paieMontant" type="number" min="1" max="99999" v-model="paiementMontant"></s-currencyInput>

                        <b-dropdown id="annee" :text="$t('g_Annee')">
                            <b-dropdown-item @click="annee = 2020">2020</b-dropdown-item>
                            <b-dropdown-item @click="annee = 2021">2021</b-dropdown-item>
                            <b-dropdown-item @click="annee = 2022">2022</b-dropdown-item>
                            <b-dropdown-item @click="annee = 2023">2023</b-dropdown-item>
                            <b-dropdown-item @click="annee = 2024">2024</b-dropdown-item>
                            <b-dropdown-item @click="annee = 2025">2025</b-dropdown-item>
                            <b-dropdown-item @click="annee = 2026">2026</b-dropdown-item>
                            <b-dropdown-item @click="annee = 2027">2027</b-dropdown-item>
                            <b-dropdown-item @click="annee = 2028">2028</b-dropdown-item>
                            <b-dropdown-item @click="annee = 2029">2029</b-dropdown-item>
                            <b-dropdown-item @click="annee = 2030">2030</b-dropdown-item>
                        </b-dropdown>
                        <br>
                        {{annee}}

                        <br><br>

                        <b-dropdown id="periode" :text="$t('p_Periode')">
                            <b-dropdown-item @click="periode = 1">{{$t('p_Periode1')}}</b-dropdown-item>
                            <b-dropdown-item @click="periode = 2">{{$t('p_Periode2')}}</b-dropdown-item>
                            <b-dropdown-item @click="periode = 3">{{$t('p_Periode3')}}</b-dropdown-item>
                            <b-dropdown-item @click="periode = 4">{{$t('p_Periode4')}}</b-dropdown-item>
                            <b-dropdown-item @click="periode = 5">{{$t('p_Periode5')}}</b-dropdown-item>
                            <b-dropdown-item @click="periode = 6">{{$t('p_Periode6')}}</b-dropdown-item>
                            <b-dropdown-item @click="periode = 7">{{$t('p_Periode7')}}</b-dropdown-item>
                            <b-dropdown-item @click="periode = 8">{{$t('p_Periode8')}}</b-dropdown-item>
                            <b-dropdown-item @click="periode = 9">{{$t('p_Periode9')}}</b-dropdown-item>
                            <b-dropdown-item @click="periode = 10">{{$t('p_Periode10')}}</b-dropdown-item>
                            <b-dropdown-item @click="periode = 11">{{$t('p_Periode11')}}</b-dropdown-item>
                            <b-dropdown-item @click="periode = 12">{{$t('p_Periode12')}}</b-dropdown-item>
                        </b-dropdown>
                        <br>
                        {{$t('p_Periode' + periode)}}

                    </div>

                    <p class="subTitle"></p>
                    <div class = "backForm2 aLeft">
                        <b-button class="btnReset" :variant="getTheme.danger" @click="resetAll(false)">{{$t('g_Efface')}}</b-button>
                        <b-button :disabled="checkCreateMagasin" type="button" class="btnSave" :variant="getTheme.success" @click="sendMagForm()">{{$t('g_Ajouter')}}</b-button>
                    </div>
                </div>
            </b-col>
            <!--FIN - Ajout de paiement ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->


            <!--Affichage des paiements ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->
            <b-col :xs="pSize.right.xs" :sm="pSize.right.sm" :md="pSize.right.md" :lg="pSize.right.lg" :xl="pSize.right.xl" v-if="showPage == '4'">
                <div class="backInfoCornerSB">
                    <p class="titleBtn1" @click="resetAll(true)"><b-icon icon="arrow-left" :variant="getTheme.dark" font-scale="1" animation="cylon"></b-icon> {{$t('g_Retour')}}</p>

                    <b-list-group>
                        <span v-for="(lic) in licenceList" :key="lic.index">
                            <span v-for="(licMag) in lic.Magasin" :key="licMag.index">
                                <b-list-group-item class="lstPaiementMag" v-if="licMag.modeDemo==false">
                                    <b-row>

                                        <!--Nom commerce [Numero magasin]-->
                                        <b-col xs="12" sm="12" md="12" lg="12" xl="4" class="paiementNomBack">
                                            <span class="addBold">{{lic.nomLicence}}</span> <span class="paiementMagBack">{{lic.licence}}.{{licMag.magNumber}}</span>
                                        </b-col>

                                        <!--Type-->
                                        <b-col xs="12" sm="6" md="6" lg="6" xl="4" class="paiementTypeBack">

                                            <span v-if="licMag.paiementVL==0">
                                            <span class="mensuel">{{$t('p_Location')}}</span> /
                                                    <span v-if="licMag.paiement==0">
                                                        <span class="mensuel">{{$t('p_Mensuel')}}</span>
                                                    </span>
                                                    <span v-else-if="licMag.paiement==1">
                                                        <span class="annuel">{{$t('p_Annuel')}}</span>
                                                    </span>
                                            </span>

                                            <span v-if="licMag.paiementVL==1">
                                                <span class="annuel">{{$t('p_Vente')}}</span>
                                            </span>

                                        </b-col>

                                        <!--Montant-->
                                        <b-col xs="12" sm="6" md="6" lg="6" xl="4" class="paiementMontantBack">
                                            {{$FM(licMag.paiementMontant,2)}}
                                            <span v-if="licMag.paiement==1">
                                                / {{$t('p_Mensuel')}} : {{$FM((licMag.paiementMontant / 12),2, '.', ' ')}}
                                            </span>

                                        </b-col>

                                    </b-row>

                                    <b-row>
                                        Voir les paiements effectué
                                    </b-row>


                                </b-list-group-item>
                            </span>
                        </span>
                    </b-list-group>


                </div>
            </b-col>
            <!--FIN - Affichage des paiements ++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++-->

        </b-row>
    </div>
</template>

<script>
import {mapGetters} from 'vuex'
import axios from 'axios';

export default{
    name: "licence",
    components: {

    },
    data() {
        return{
            id: -1,
            pSize: this.$store.getters.getPageSize,
            showPage: '0', //0=NULL, 1=Details Licence, 2=Creation magasin
            nomLicence: '',
            createdLicence: null,
            output: false,
            outputMag: false,
            outputDbCreate: null,
            annee: '2020',
            periode: 1,
            fields: [
              //{
              //  key: 'licence',
              //  label: this.$i18n.t('p_Licence'),
              //  sortable: true
              //},
              {
                key: 'nomLicence',
                label: this.$i18n.t('p_LicenceNom'),
                sortable: true
              },
              {
                key: 'qteMag',
                label: this.$i18n.t('p_QteMagasin'),
                sortable: true,
              },
              {
                key: 'details',
                label: this.$i18n.t('p_Details'),
                sortable: true,
              }
            ],
            actif: true,
            licenceList: null,
            licenceDetail: null,
            txtRecherche: '',
            modeDemo: false,
            tpv: false,
            wooCommerce: false,
            inventaire: false,
            ecranPub: false,
            compteClient: false,
            horodateur: false,
            etiquette: false,
            certCadeaux: false,
            nomCommerce: '',
            adresse: '',
            ville: '',
            zipCode: '',
            tel: '',
            qtePos: 1,
            note: '',
            paiementMontant: 0,
            paiementNote: '',
            paiement: false,
            paiementVL: false
        }
    },
    methods: {
        sendMagForm(){
            if (this.showPage == '2'){this.formSubmitMag()}
            if (this.showPage == '3'){this.formModifMag()}
        },
        addPaiement(){
            this.showPage = '5';
        },
        modifLicence(index) {
            this.showPage = '3';
            
            this.id = this.licenceDetail.item.Magasin[index].id
            this.nomCommerce = this.licenceDetail.item.Magasin[index].nom
            this.adresse = this.licenceDetail.item.Magasin[index].add1
            this.ville = this.licenceDetail.item.Magasin[index].add2
            this.zipCode = this.licenceDetail.item.Magasin[index].zipCode
            this.tel = this.licenceDetail.item.Magasin[index].tel
            
            this.actif = this.licenceDetail.item.Magasin[index].actif
            this.modeDemo = this.licenceDetail.item.Magasin[index].modeDemo
            this.tpv = this.licenceDetail.item.Magasin[index].tpv
            this.wooCommerce = this.licenceDetail.item.Magasin[index].wooCommerce
            this.inventaire = this.licenceDetail.item.Magasin[index].inventaire
            this.ecranPub = this.licenceDetail.item.Magasin[index].ecranPub
            this.compteClient = this.licenceDetail.item.Magasin[index].compteClient
            this.horodateur = this.licenceDetail.item.Magasin[index].horodateur
            this.etiquette = this.licenceDetail.item.Magasin[index].etiquette
            this.certCadeaux = this.licenceDetail.item.Magasin[index].certCadeaux

            this.paiement = this.licenceDetail.item.Magasin[index].paiement
            this.paiementNote = this.licenceDetail.item.Magasin[index].paiementNote
            this.paiementMontant = this.licenceDetail.item.Magasin[index].paiementMontant
            this.paiementVL = this.licenceDetail.item.Magasin[index].paiementVL

            this.note = this.licenceDetail.item.Magasin[index].licNote
        },
        scrollToTop() {
                window.scrollTo(0,0);
        },
        resetAll(back){

            if (back == true){
                this.showPage=0
                this.txtRecherche=''
            }

            this.id = -1
            this.actif= true
            this.modeDemo= false
            this.tpv= false
            this.wooCommerce= false
            this.inventaire= false
            this.ecranPub= false
            this.compteClient= false
            this.horodateur= false
            this.etiquette= false
            this.certCadeaux= false
            this.nomCommerce= ''
            this.adresse= ''
            this.ville= ''
            this.zipCode= ''
            this.tel= ''
            this.qtePos= 1
            this.note= ''
            this.outputDbCreate= null
            this.paiement = 0
            this.paiementNote = ''
            this.paiementMontant = false
            this.paiementVL = false
            //this.output= false
        },
        resetLicence(){
            this.nomLicence= ''
            this.output= false
            this.outputDbCreate= false
        },
        pushto(link) {
            console.log(link)
            this.$router.push(link)
        },
        loadLicence() {
          axios.get(this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.portail.apiLicence + '?invert=false', {headers: {'Authorization': `Basic ${this.$CKey()}`}})
            .then(response => {
              this.licenceList = response.data
            })
            .catch(e => {
              this.errors.push(e)
            })
        },
        showDetails(row){
            this.showPage = '1';
            this.licenceDetail = row;
            this.txtRecherche = this.licenceDetail.item.nomLicence;
        },
        creatLicence(row){
            this.showPage = '2';
            this.licenceDetail = row;
            this.licenceNumber = this.licenceDetail.item.licence;
            this.txtRecherche = this.licenceDetail.item.nomLicence;
        },
        showLicenceChange(){
            this.showLicence = !this.showLicence
        },
        formSubmit() {
            //e.preventDefault();
                let currentObj = this;
                axios.post(this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.portail.apiLicence, {
                    nomLicence: this.nomLicence
                }, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                .then(function (response) {
                    currentObj.output = true;
                    currentObj.createdLicence = response.data;
                })
                .catch(function (error) {
                    currentObj.output = error;
                });
        },
        formSubmitMag() {
            this.scrollToTop()

            //Création de la base de donnée
            this.createDatabase(this.licenceDetail.item.licence)

                let currentObj = this;
                axios.post(this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.portail.apiMagasin, {
                    id: this.id,
                    licence: this.licenceNumber,
                    actif: this.actif,
                    nom: this.nomCommerce,
                    add1: this.adresse,
                    add2: this.ville,
                    zipCode: this.zipCode,
                    tel: this.tel,
                    licNote: this.note,
                    qtePos: this.qtePos,
                    modeDemo: this.modeDemo,
                    tpv: this.tpv,
                    wooCommerce: this.wooCommerce,
                    inventaire: this.inventaire,
                    ecranPub: this.ecranPub,
                    compteClient: this.compteClient,
                    horodateur: this.horodateur,
                    etiquette: this.etiquette,
                    certCadeaux: this.certCadeaux,
                    paiement: this.paiement,
                    paiementNote: this.paiementNote,
                    paiementMontant: this.paiementMontant,
                    paiementVL: this.paiementVL
                }, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                .then(function (response) {
                currentObj.outputMag = response.data;
                })
                .catch(function (error) {
                    currentObj.outputMag = error;
                });
        },
        formModifMag() {
            this.scrollToTop()

                let currentObj = this;
                axios.patch(this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.portail.apiMagasin, {
                    id: this.id,
                    licence: this.licenceNumber,
                    actif: this.actif,
                    nom: this.nomCommerce,
                    add1: this.adresse,
                    add2: this.ville,
                    zipCode: this.zipCode,
                    tel: this.tel,
                    licNote: this.note,
                    qtePos: this.qtePos,
                    modeDemo: this.modeDemo,
                    tpv: this.tpv,
                    wooCommerce: this.wooCommerce,
                    inventaire: this.inventaire,
                    ecranPub: this.ecranPub,
                    compteClient: this.compteClient,
                    horodateur: this.horodateur,
                    etiquette: this.etiquette,
                    certCadeaux: this.certCadeaux,
                    paiement: this.paiement,
                    paiementNote: this.paiementNote,
                    paiementMontant: this.paiementMontant,
                    paiementVL: this.paiementVL
                }, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
                .then(function (response) {
                currentObj.outputMag = response.data;
                })
                .catch(function (error) {
                    currentObj.outputMag = error;
                });

                this.resetAll(true)
                this.loadLicence()
        },
        createDatabase(licNumber) {
            this.outputDbCreate = false
            console.log('1')
            axios.get(this.$store.getters.getApiAdress + this.$store.getters.getApiAdd.portail.apiDatabasedbCreate + '?licence=' + licNumber, {headers: {'Authorization': `Basic ${this.$CKey()}`}})
              .then(response => {
                console.log('2')
                this.outputDbCreate = response.data
              })
              .catch(e => {
                console.log('3')
                this.errors.push(e)
              })
        },
        selectOption(value) {
            //this.modeDemo = value
            this.tpv = value
            this.wooCommerce = value
            this.inventaire = value
            this.ecranPub = value
            this.compteClient = value
            this.horodateur = value
            this.etiquette = value
            this.certCadeaux = value
        }
    },
    computed: {
        ...mapGetters(['getTheme', 'getApiAdd', 'getLanguage', 'getApiAdress', 'getPageSize']),
        filteredLicence() {
            const search = this.txtRecherche.toLowerCase().trim();
            if (!search) return this.licenceList;
            return this.licenceList.filter(c => c.nomLicence.toLowerCase().indexOf(search) > -1);
        },
        checkCreateLicence() {
            if (
                this.nomLicence.length > 2
                ) {return false}

            return true
        },
        checkCreateMagasin() {
            if (
                this.nomCommerce.length > 3
                && this.adresse.length > 5
                && this.ville.length > 4
                && this.zipCode.length > 5
                && this.tel.length > 7
                ) {return false}

            return true
        }
    },
    mounted() {
        this.loadLicence() //charger les licences
    },

    watch: {
        getLanguage: function() {
            this.fields[0].label = this.$i18n.t('p_Licence')
            this.fields[1].label = this.$i18n.t('p_LicenceNom')
            this.fields[2].label = this.$i18n.t('p_QteMagasin')
            this.fields[3].label = this.$i18n.t('p_Details')
        },
        output: function() {
            if (this.output){
                this.loadLicence()
            }
        },
        outputMag: function() {
            if (this.outputMag){
                this.loadLicence()
            }
        }
    }
}
</script>

<style scoped lang="scss">
.paiementNomBack{
    height: 35px;
    //border: 1px solid lightgray;
    background-color: gray;
    color: white;
    padding-top: 7px;
}
.paiementMagBack{
    height: 35px;
    //border: 1px solid lightgray;
    background-color: gray;
    color: black;
    padding-top: 7px;
}
.paiementMontantBack{
    height: 35px;
    padding-top: 7px;
    background-color: lightgray;
}
.paiementTypeBack{
    height: 35px;
    padding-top: 7px;
    background-color: lightgray;
}
.paiementNomBackLicence{
    height: 35px;
    padding-top: 7px;
    background-color: $cContainerLeftBorder;
    color: $cText;
}
.lstPaiementMag{
    border: 0px solid lightgray;
}
.tx{
    color: darkgray;
}
.mensuel{
    color: darkgreen;
    font-weight: bold;
}
.annuel{
    color: darkred;
    font-weight: bold;
}
.btnSearch
{
    margin-bottom: 10px;
    margin-left: 5%;
    width: 30%;
    height: 40px;
}
.btnPaiement
{
    margin-bottom: 10px;
    //margin-left: 5%;
    width: 100%;
    height: 40px;
}
.addLicence{
    width: 65%;
}
.addLicContainer{
    width: 100%;
    margin: 0px 0px 0px 0px;
}
.addBtn{
    background-color: $cBackLogin;
    color: $cTextLogin;
    width: 100%;
    font-size: 15px;
    font-weight: bold;
}
.text{
    color: $cTextLogin;
    margin-bottom: 10px;
}
.btnAllNone{
    margin: 10px 10px 10px 0px;
    width: 30%;
}
.qtePos{
    margin-bottom: 10px;
    width: 20%;
}
.btnSave{
    width: 47%;
    margin-left: 6%;
    margin-bottom: -10px;
}
.btnReset{
    width: 47%;
    margin-bottom: -10px;
}
.tblWidth{
    width: 100%;
}
</style>